const KNOWN_DUMMY_USER_NAMES = ['traveler', 'guest user', 'test user'];

export function isDummyUserName(name: string): boolean {
  if (!name) {
    return false;
  }
  return KNOWN_DUMMY_USER_NAMES.includes(name.trim().toLowerCase());
}
